<template>
    <button :type="type" class="btn btn-style btn-secondary w-172">
        <span><slot></slot></span>
    </button>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'button',
            },
        }
    }
</script>
